// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button-module__button--AisLs {
    background-color: #151b23;
    color: white;
    border: 1px solid rgb(61, 68, 77);
    padding: 8px 16px;
    font-size: 14px;
    cursor: pointer;
    transition:
        background-color 200ms ease,
        border-color 200ms ease;
}
.Button-module__button--AisLs:hover {
    background-color: #30363d;
    border-color: #8b949e;
}
.Button-module__button--AisLs:active {
    background-color: #161b22;
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,iCAAiC;IACjC,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf;;+BAE2B;AAC/B;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B","sourcesContent":[".button {\n    background-color: #151b23;\n    color: white;\n    border: 1px solid rgb(61, 68, 77);\n    padding: 8px 16px;\n    font-size: 14px;\n    cursor: pointer;\n    transition:\n        background-color 200ms ease,\n        border-color 200ms ease;\n}\n.button:hover {\n    background-color: #30363d;\n    border-color: #8b949e;\n}\n.button:active {\n    background-color: #161b22;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button-module__button--AisLs`
};
export default ___CSS_LOADER_EXPORT___;
